import Footer from "./Footer";
import Navbar from "./Navbar";
import WhyChooseUs from "./WhyChooseUs";
import LoanCalculator from "./LoanCalculator";
import LoanSteps from "./LoanSteps";
import CheckEligibility from "./CheckEligibility";
import HomeFAQ from "./HomeFAQ";

// Premium Assets
import herosectionbg from "../assets/herosectionbg.png";
import herosectionbgmobile from "../assets/herosectionbgmobile.png";

function CompanyLanding() {
  return (
    <div className="min-h-screen w-full bg-[#D6EDFE] text-[var(--text-primary)] relative overflow-x-hidden font-sans selection:bg-[var(--primary)] selection:text-white">

      <div className="relative z-10 flex w-full flex-col items-center">
        <Navbar />

        {/* Home Hero Section */}
        <section 
          className="w-full pt-20 sm:pt-28 lg:pt-36 pb-6 lg:pb-16 px-6 lg:px-20 min-h-[92vh] 2xl:min-h-screen flex items-start lg:items-center overflow-hidden relative hero-section-bg" 
          style={{ '--hero-bg-url': `url(${herosectionbg})` } as React.CSSProperties}
        >
          
          <div className="max-w-[1500px] mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-0 lg:gap-12 items-start lg:items-center relative z-10">
            
            {/* Left Content Column */}
            <div className="md:col-span-1 lg:col-span-6 flex flex-col items-center md:items-start text-center md:text-left gap-5 md:gap-8 relative z-10 w-full">
              
              {/* Badge */}
              <div className="inline-flex items-center m-auto md:m-0 gap-2 px-4 py-1.5 rounded-full border border-[var(--primary)]/30 bg-white/60 shadow-[0_2px_10px_rgba(0,150,255,0.05)]">
                <span className="text-[var(--primary)] text-xs font-extrabold"><svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.94878 10.9111L2.96158 9.24846L1.09111 8.8328L1.27296 6.91036L0 5.45555L1.27296 4.00074L1.09111 2.0783L2.96158 1.66264L3.94878 0L5.71534 0.753386L7.4819 0L8.46909 1.66264L10.3396 2.0783L10.1577 4.00074L11.4307 5.45555L10.1577 6.91036L10.3396 8.8328L8.46909 9.24846L7.4819 10.9111L5.71534 10.1577L3.94878 10.9111ZM4.39042 9.58618L5.71534 9.01465L7.06624 9.58618L7.79364 8.3392L9.22248 8.00147L9.09258 6.54666L10.0538 5.45555L9.09258 4.33846L9.22248 2.88365L7.79364 2.5719L7.04026 1.32492L5.71534 1.89645L4.36444 1.32492L3.63703 2.5719L2.2082 2.88365L2.33809 4.33846L1.37688 5.45555L2.33809 6.54666L2.2082 8.02745L3.63703 8.3392L4.39042 9.58618ZM5.16978 7.30005L8.10539 4.36444L7.37798 3.61105L5.16978 5.81925L4.05269 4.72814L3.32529 5.45555L5.16978 7.30005Z" fill="#008FF0"/>
</svg>
</span>
                <span className="text-[#334155]  text-[7px] md:text-[11px] font-bold tracking-wider uppercase">
               FAST | PAPERLESS | RBI APPROVED LENDERS
                </span>
              </div>

              {/* Heading */}
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[52px] xl:text-[68px] font-bold text-[#0F172A] leading-[1.2] tracking-tight">
                Get Funds When <br />
                <span className="text-[var(--primary)]">Life Can't Wait</span>
              </h1>

              {/* Subheading */}
              <p className=" text-sm md:text-[21px] font-medium text-[#334155] leading-snug -mt-1">
                Up to <span className="text-[var(--primary)] font-bold">₹5 Lakhs</span> approved online in minutes.
              </p>

              <div className="flex flex-row flex-nowrap items-center justify-center md:justify-start gap-x-4 gap-y-2">
                {[
                  "No Paperwork",
                  "Instant Credit",
                  "Lowest Rates"
                ].map((item) => (
                  <div key={item} className="flex items-center gap-2">
                    <div className="flex-shrink-0 flex items-center justify-center w-[20px] h-[20px] rounded-full bg-[#41A655]">
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth="3.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-[9px] sm:text-[17px] font-bold text-[#1E293B]">{item}</span>
                  </div>
                ))}
              </div>

              {/* CTA Button — full width on mobile, auto width on sm+ */}
              <div className="">
                <a
                  href={import.meta.env.VITE_WEBSITE_LINK}
                  target="_blank"
                  className="flex sm:inline-flex items-center justify-center gap-2 w-full sm:w-auto px-4 md:px-9 py-1 md:py-4 rounded-[10px] bg-[#41A655] hover:bg-[#38924A] text-white font-bold text-lg transition-all active:scale-95 shadow-[0_6px_20px_rgba(65,166,85,0.25)]"
                >
                  Check Eligibility 
                  <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>

              {/* Stats Row — desktop only (lg+); on mobile/iPad shows below the image */}
              <div className="hidden lg:flex flex-wrap items-center gap-y-4 w-full pt-8 md:mt-2">
                {[
                  { value: "4.8/5", label: "User Rating" },
                  { value: "₹500 Cr +", label: "Loans Disbursed" },
                  { value: "50,000+", label: "Happy Users" },
                  { value: "100%", label: "Digital Process" }
                ].map((stat, i, arr) => (
                  <div key={stat.label} className="flex items-center">
                    <div className="flex flex-col pr-6 sm:pr-8">
                      <span className="text-xl sm:text-2xl font-black text-[var(--primary)]">{stat.value}</span>
                      <span className="text-xs sm:text-[13px] font-semibold text-slate-500 mt-1 whitespace-nowrap">{stat.label}</span>
                    </div>
                    {i < arr.length - 1 && (
                      <div className="h-10 w-[1px] bg-slate-300/60 mr-6 sm:mr-8" />
                    )}
                  </div>
                ))}
              </div>

            </div>

            {/* Mobile & Tablet image — shown below content, hidden on desktop (lg+) */}
            <div className="block lg:hidden w-full max-w-[600px] mx-auto pointer-events-none mt-4">
              <img
                src={herosectionbgmobile}
                alt="Hero illustration"
                className="w-full object-contain"
              />
            </div>

            {/* Stats Row — mobile & tablet only, below the image */}
            <div className="lg:hidden col-span-full flex flex-nowrap items-center justify-between w-full  pt-4 border-t border-slate-200">
              {[
                { value: "4.8/5", label: "User Rating" },
                { value: "₹500 Cr +", label: "Loans Disbursed" },
                { value: "50,000+", label: "Happy Users" },
                { value: "100%", label: "Digital Process" }
              ].map((stat, i, arr) => (
                <div key={stat.label} className="flex items-center">
                  <div className="flex flex-col pr-2 sm:pr-5">
                    <span className="text-sm sm:text-xl font-black text-[var(--primary)] whitespace-nowrap">{stat.value}</span>
                    <span className="text-[9px] sm:text-[13px] font-semibold text-slate-500 mt-0.5 whitespace-nowrap">{stat.label}</span>
                  </div>
                  {i < arr.length - 1 && (
                    <div className="h-7 w-[1px] bg-slate-300/60 mr-2 sm:mr-5" />
                  )}
                </div>
              ))}
            </div>

            {/* Right Spacer Column — lg desktop only */}
            <div className="hidden lg:block lg:col-span-6 pointer-events-none" />

          </div>
        </section>

        {/* Home Sections Container */}
        <div className="w-full bg-white relative z-10">
          <WhyChooseUs />
          <div className="w-full bg-[#EAF1F6]">
            <LoanCalculator />
          </div>
          <LoanSteps />
          <CheckEligibility />
          <HomeFAQ />

          {/* Repay Now Call to Action Section */}
          <section className="w-full py-16 md:py-24 px-6 lg:px-20 bg-gradient-to-b from-white to-[#F0F7FD] relative overflow-hidden">
            <div className="max-w-[1100px] mx-auto relative z-10">
              <div className="bg-gradient-to-r from-[var(--primary)]/10 via-[var(--primary)]/5 to-[var(--primary)]/10 border border-[var(--primary)]/20 rounded-3xl p-8 md:p-14 flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16 shadow-[0_10px_30px_rgba(0,150,255,0.04)] backdrop-blur-sm">
                <div className="flex flex-col gap-4 text-center md:text-left md:max-w-[60%]">
                  <span className="text-[var(--primary)] text-xs md:text-sm font-extrabold uppercase tracking-widest">
                    Quick Repayment
                  </span>
                  <h2 className="text-3xl md:text-4xl font-extrabold text-[#0F172A] leading-tight">
                    Repay Your Loan in Seconds
                  </h2>
                  <p className="text-slate-600 text-sm md:text-base font-medium leading-relaxed">
                    Make quick, secure, and hassle-free payments online. Pay via UPI, Net Banking, or Debit Cards and get instant confirmation.
                  </p>
                </div>
                <div className="flex-shrink-0 w-full md:w-auto text-center">
                  <a
                    href={`${import.meta.env.VITE_WEBSITE_LINK}/repay-now`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 px-8 py-4 w-full md:w-auto rounded-xl bg-[var(--primary)] hover:bg-[var(--primary-hover)] text-white font-bold text-lg shadow-[0_6px_20px_rgba(0,150,255,0.25)] hover:shadow-[0_8px_25px_rgba(0,150,255,0.35)] transition-all duration-300 active:scale-95"
                  >
                    Repay Now
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* Ambient decorative elements */}
            <div className="absolute top-0 right-1/4 w-96 h-96 bg-[var(--primary)]/5 rounded-full blur-3xl pointer-events-none -z-10" />
            <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[var(--secondary-accent)]/5 rounded-full blur-3xl pointer-events-none -z-10" />
          </section>
        </div>

        <Footer />
      </div>

    </div>
  );
}

export default CompanyLanding;
